import { useEffect } from 'react';

import { UseCreditAgreementStore } from './store';
import { CreditAgreementFullArtifact } from '~/core/routes/settings/implementations/common/types';
import { useGetCreditAgreementFullArtifactImplementationPortalWipQuery } from '~/core/routes/settings/implementations/implementations.gql.generated';

export const useFetchCreditAgreement = (
  useStore: UseCreditAgreementStore,
  facilityId: string,
) => {
  const setCreditAgreement = useStore((store) => store.setCreditAgreement);

  const {
    data,
    error,
  } = useGetCreditAgreementFullArtifactImplementationPortalWipQuery({
    variables: { creditFacilityId: facilityId },
  });

  if (error) throw error;

  useEffect(() => {
    if (data) {
      const creditAgreementWip = JSON.parse(
        data.creditAgreementFullArtifactWip.wip.creditAgreement,
      ) as CreditAgreementFullArtifact;
      setCreditAgreement(creditAgreementWip);
    }
  }, [data, setCreditAgreement]);
};
